export const checkoutOrderLabels = {
  orderShipping: 'Shipping',
  orderDiscount: 'Discounts',
  orderTotalTax: 'Total before tax',
  orderEstTax: 'Estimated tax to be collected',
  orderTotal: 'Total',
  orderTotalIncTax: 'Total (inc tax)',
  orderPaymentDue: 'Due today',
  orderSubtotal: 'Subtotal',
};
